import { jsx } from 'react/jsx-runtime';
import { s as styleInject } from './style-inject.es-Bff-fD1R.js';

const APP_STORE_ICON_WIDTH = 85;
const APP_STORE_ICON_HEIGHT = 28;
const GOOGLE_PLAY_STORE_ICON_WIDTH = 92.69;
const GOOGLE_PLAY_STORE_ICON_HEIGHT = 28;

const appStoreConfigMap = {
    apple: {
        alt: '  Apple app store icon',
        height: APP_STORE_ICON_HEIGHT,
        imgSrc: 'https://i.i-sgcm.com/all/icon_ap.png',
        url: 'https://itunes.apple.com/us/app/sgcarmart/id962261200?mt=8',
        width: APP_STORE_ICON_WIDTH,
    },
    google: {
        alt: 'Google play store icon',
        height: GOOGLE_PLAY_STORE_ICON_HEIGHT,
        imgSrc: 'https://i.i-sgcm.com/all/icon_pl.png',
        url: 'https://play.google.com/store/apps/details?id=com.sgcarmart.app',
        width: GOOGLE_PLAY_STORE_ICON_WIDTH,
    },
};

var css_248z = ".SGCM_UIKIT_NEXT_AppStoreList_listAppStore_1w2ny_1 {\n  display: flex;\n  padding: 0;\n  margin: 0;\n  column-gap: 12px;\n  list-style-type: none;\n}\n\n.SGCM_UIKIT_NEXT_AppStoreList_linkAppStore_1w2ny_9 {\n  display: block;\n  line-height: 0;\n}\n.SGCM_UIKIT_NEXT_AppStoreList_linkAppStore_1w2ny_9:hover {\n  opacity: 0.6;\n  text-decoration: none;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGFBQWE7RUFDYixVQUFVO0VBQ1YsU0FBUztFQUNULGdCQUFnQjtFQUNoQixxQkFBcUI7QUFDdkI7O0FBRUE7RUFDRSxjQUFjO0VBQ2QsY0FBYztBQUNoQjtBQUNBO0VBQ0UsWUFBWTtFQUNaLHFCQUFxQjtBQUN2QiIsImZpbGUiOiJzdHlsZXMubW9kdWxlLnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIubGlzdEFwcFN0b3JlIHtcbiAgZGlzcGxheTogZmxleDtcbiAgcGFkZGluZzogMDtcbiAgbWFyZ2luOiAwO1xuICBjb2x1bW4tZ2FwOiAxMnB4O1xuICBsaXN0LXN0eWxlLXR5cGU6IG5vbmU7XG59XG5cbi5saW5rQXBwU3RvcmUge1xuICBkaXNwbGF5OiBibG9jaztcbiAgbGluZS1oZWlnaHQ6IDA7XG59XG4ubGlua0FwcFN0b3JlOmhvdmVyIHtcbiAgb3BhY2l0eTogMC42O1xuICB0ZXh0LWRlY29yYXRpb246IG5vbmU7XG59Il19 */";
var styles = {"listAppStore":"SGCM_UIKIT_NEXT_AppStoreList_listAppStore_1w2ny_1","linkAppStore":"SGCM_UIKIT_NEXT_AppStoreList_linkAppStore_1w2ny_9"};
styleInject(css_248z);

const AppStoreList = () => (jsx("ul", { className: styles.listAppStore, children: Object.entries(appStoreConfigMap)
        .map(([appStore, { url, imgSrc, alt, width, height, }]) => (jsx("li", { children: jsx("a", { className: styles.linkAppStore, href: url, children: jsx("img", { alt: alt, height: height, src: imgSrc, width: width }) }) }, appStore))) }));

export { AppStoreList as A };
//# sourceMappingURL=component-C84AhI26.js.map
